import "./Contact.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import SyncWithUs from "./sections/SyncWithUs";
import OurHub from "./sections/OurHub";
import StorageUnitInventory from "./sections/StorageUnitInventory";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <VoltMainHeader />
      <StorageUnitInventory />
      <OurHub />
      <SyncWithUs />
      <Footer />
    </div>;
}